import { render, staticRenderFns } from "./exhibitionExtra.vue?vue&type=template&id=b4501822&scoped=true"
import script from "./exhibitionExtra.vue?vue&type=script&setup=true&lang=js"
export * from "./exhibitionExtra.vue?vue&type=script&setup=true&lang=js"
import style0 from "./exhibitionExtra.vue?vue&type=style&index=0&id=b4501822&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4501822",
  null
  
)

export default component.exports